module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/hairmake_sns_01-99f80034279aaea3a7ff50f9930268c3.jpg";